exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".branch-label{background:hsla(0,0%,100%,.15);padding:1px 8px;border-radius:5px;color:#fff}.branch-label.small{font-size:.8em;padding:2px 5px}.branch-label .el-icon--right{font-size:8px;margin-left:2px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1de59a3f","scoped":false,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./client/src/components/basic/BranchLabel.vue
// module id = 297
// module chunks = 0